/*
 * 화면 언어 코드를 HTML lang 값(BCP 47)으로 바꾼다.
 * 이 앱의 'sh' 는 세르비아어 키릴 문자, 'sr' 은 세르비아어 라틴 문자다.
 * 'sh' 는 옛 세르보크로아티아어 코드라 브라우저·스크린리더가 세르비아어로 알아보지 못할 수 있어
 * 문자 체계를 붙인 세르비아어 코드로 넣는다. 나머지 언어는 코드 그대로다.
 */
const HTML_LANG = Object.freeze({sh: "sr-Cyrl", sr: "sr-Latn"})

export function toHtmlLang(locale) {
  const code = String(locale || "")
  return HTML_LANG[code] || code
}

/*
 * 점역 언어(brailleLanguageList.json 의 language·code)를 lang 값으로 바꾼다.
 * 목록의 code 는 화면 언어 추천에도 쓰여 그대로 두고, 표준 코드와 다른 것만 여기서 고친다
 * (dk·gr·se 는 나라 코드, 중국어 둘은 같은 zh, 세르비아어 목록 이름은 키릴 문자).
 */
const BRAILLE_LANG = Object.freeze({
  "simplified chinese": "zh-CN",
  taiwan: "zh-TW",
  serbian: "sr-Cyrl",
  danish: "da",
  greek: "el",
  swedish: "sv",
})

export function toBrailleLang(language, code) {
  return BRAILLE_LANG[String(language || "")] || String(code || "") || undefined
}
